import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_INITIALIZER  } from '@angular/core';
import { FndModule, FndNotificationsService } from 'findomestic-ui-components';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'app/modal/modal.module';
import { ApiService } from 'app/shared/service/api-service/api-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleMapsLoaderService } from './shared/service/google-service/google-maps-loader.service';
import { TrovaAtmService } from './trova-atm.service';
import { TrovaAtmComponent } from './app.component';
import { CapitalizePipe } from './shared/pipes/capitalize.pipe';

// ALL ENVIRONMENTS
import { environment } from 'environments/environment'; // the default angular environment
import { EnvironmentService } from 'app/shared/service/environments-service/environments-service';
import { ErrorHandlingComponent } from 'app/error-handling/error-handling.component';
import { ModalService } from './modal/modal.service';
import { SelectAtmComponent } from './select-atm/select-atm.component';

import { registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';
registerLocaleData(localeIT);

export function loadEnv(environment) {
    return new EnvironmentService(environment);
}

export function loadGoogleMapsFactory(loader: GoogleMapsLoaderService) {
    loader.getApiKey();
    return () => loader.loadGoogleMapsApi();
}


@NgModule({ declarations: [
        TrovaAtmComponent,
        //ModalComponent,
        CapitalizePipe,
        ErrorHandlingComponent,
        SelectAtmComponent
    ],
    bootstrap: [
        TrovaAtmComponent
    ], imports: [CommonModule,
        FndModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        GoogleMapsModule], providers: [
        {
            provide: 'DEFAULT_ENVIRONMENT', useValue: environment
        },
        {
            provide: EnvironmentService,
            useFactory: loadEnv,
            deps: ['DEFAULT_ENVIRONMENT']
        },
        {
            provide: APP_INITIALIZER,
            useFactory: loadGoogleMapsFactory,
            deps: [GoogleMapsLoaderService],
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'it-IT'
        },
        ApiService,
        ModalService,
        FndNotificationsService,
        TrovaAtmService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
